/*
 * UpdatePopover Messages
 *
 * This contains all the text for the UpdatePopover container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.UpdatePopover';

export default defineMessages({
  refresh: {
    id: `${scope}.refresh`,
    defaultMessage: 'Refresh!',
  },
  updateAvailable: {
    id: `${scope}.updateAvailable`,
    defaultMessage: 'A new update is available!',
  },
});
